import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import GUI from 'lil-gui'
import options from "./js/options.js";
import light from "./js/light.js";
import baseFloor from "./js/base-floor.js";
import loadingManager from "./js/loader.js";
import {pdfCreate} from "./js/pdf.js";
import {ARButton, DRACOLoader, RGBELoader} from "three/addons";
import theme from "./js/theme.js";
import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js';
import {initAIImageGenerator} from "./js/ai.js";


// const gui = new GUI()

const canvasContainer = document.querySelector('#canvas-container');

const canvasContainerSize = canvasContainer.getBoundingClientRect()

const canvas = document.querySelector('canvas.webgl')

const scene = new THREE.Scene()


const dracoLoader = new DRACOLoader(loadingManager)

dracoLoader.setDecoderPath('./draco/')
const gltfLoader = new GLTFLoader(loadingManager)

gltfLoader.setDRACOLoader(dracoLoader)

const modelsLibrary = {}

const assets = [
    { name: 'black', url: './models/wall_street_desk_black_oak-v1.glb' },
    { name: 'english', url: './models/wall_street_desk_english-v1.glb' },
    { name: 'brown', url: './models/wall_street_desk_rich_brown-v1.glb' }
]


const sizes = {
    width: canvasContainerSize.width,
    height: canvasContainerSize.height
}


light(scene)
baseFloor(THREE, scene)
theme(scene)


const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(0, 1.3, 1.3)
scene.add(camera)

const controls = new OrbitControls(camera, canvas)
controls.target.set(0, 0.75, 0)
controls.enableDamping = true
controls.enablePan = false

controls.minDistance = 1
controls.maxDistance = 2
controls.maxPolarAngle = Math.PI / 2


const state = {
    currentModel: null
};



window.addEventListener('resize', () =>
{
    sizes.width = canvasContainer.clientWidth
    sizes.height = canvasContainer.clientHeight

    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 3))
})



const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
    preserveDrawingBuffer: true,
    alpha: true
})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setClearColor('#ffffff')
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.toneMapping = THREE.ACESFilmicToneMapping;



// const toneMappingParams = {
//     exposure: 2.5
// }

// renderer.toneMappingExposure = toneMappingParams.exposure

// gui.add(toneMappingParams, 'exposure', 0, 3, 0.01)
//     .name('Насыщенность сцены')
//     .onChange((value) => {
//         renderer.toneMappingExposure = value
//     })



// Создаём простой environment из цвета — без внешних файлов
const pmremGenerator = new THREE.PMREMGenerator(renderer);
const envTexture = pmremGenerator.fromScene(new RoomEnvironment()).texture;
scene.environment = envTexture;
pmremGenerator.dispose();


const clock = new THREE.Clock()
let previousTime = 0
let autoRotate = true

controls.addEventListener('start', () => {
    autoRotate = false
})


assets.forEach(asset => {
    gltfLoader.load(asset.url, async (gltf) => {
        modelsLibrary[asset.name] = gltf.scene; // Сохраняем модель по ключу

        if (asset.name === 'english') {
            state.currentModel = modelsLibrary['english']
            state.currentModel.traverse( (child) => {
                if (child.isMesh) {
                    child.castShadow = true;
                    child.receiveShadow = true;

                }
            });

            state.currentModel.position.y = 0.3

            scene.add(state.currentModel)
        }

        if (asset.name === 'black' || asset.name === 'english') {
            modelsLibrary[asset.name].traverse((child) => {
                if (child.isMesh) {
                    child.material.color.multiplyScalar(2);
                }
            });
        }

        if (asset.name === 'brown') {
            modelsLibrary[asset.name].traverse((child) => {
                if (child.isMesh) {
                    child.material.color.multiplyScalar(0.5);
                }
            });
        }





        if (Object.keys(modelsLibrary).length === 3) {
            options(state, modelsLibrary, scene, camera)
            await pdfCreate(renderer, camera, scene, state)
        }
    });
});

initAIImageGenerator({
    renderer,
    camera,
    scene,
});


renderer.xr.enabled = true;

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

if (isIOS) {
    const iosButton = document.createElement('button');
    iosButton.id = 'ARButtonIOS';


    iosButton.onclick = () => {
        const anchor = document.createElement('a');
        anchor.setAttribute('rel', 'ar');
        anchor.appendChild(document.createElement('img'));

        const urlParams = new URLSearchParams(window.location.search);

        const materialParam = urlParams.get('material');

        if (!materialParam || materialParam === 'english') anchor.setAttribute('href', './models/wall_street_desk_english.usdz');
        if ( materialParam === 'black') anchor.setAttribute('href', './models/wall_street_desk_black_oak.usdz');
        if ( materialParam === 'brown') anchor.setAttribute('href', './models/wall_street_desk_rich_brown.usdz');

        anchor.click();
    };

    canvasContainer.appendChild(iosButton);

} else {
    const webXRButton = ARButton.createButton(renderer, {
        requiredFeatures: ['hit-test']
    });
    canvasContainer.appendChild(webXRButton);
}


const reticle = new THREE.Mesh(
    new THREE.RingGeometry(0.1, 0.12, 32).rotateX(-Math.PI / 2),
    new THREE.MeshBasicMaterial({ color: 0x00ff00 })
);
reticle.matrixAutoUpdate = false;
reticle.visible = false;
scene.add(reticle);

let hitTestSource = null;
let hitTestSourceRequested = false;

renderer.setAnimationLoop((time, frame) => {
    if (frame) {
        const session = renderer.xr.getSession();

        if (hitTestSourceRequested === false) {
            session.requestReferenceSpace('viewer').then((referenceSpace) => {
                session.requestHitTestSource({ space: referenceSpace }).then((source) => {
                    hitTestSource = source;
                });
            });
            hitTestSourceRequested = true;
        }

        if (hitTestSource) {
            const hitTestResults = frame.getHitTestResults(hitTestSource);
            if (hitTestResults.length) {
                const hit = hitTestResults[0];
                const referenceSpace = renderer.xr.getReferenceSpace();
                const pose = hit.getPose(referenceSpace);

                reticle.visible = true;
                reticle.matrix.fromArray(pose.transform.matrix);
                if (state.currentModel) {
                    state.currentModel.visible = true;

                    state.currentModel.position.setFromMatrixPosition(reticle.matrix);
                    state.currentModel.position.y = -1;
                    const lookAtTarget = new THREE.Vector3(camera.position.x, state.currentModel.position.y, camera.position.z);
                    state.currentModel.lookAt(lookAtTarget);
                }
            } else {
                reticle.visible = false;
            }
        }
    }

    renderer.render(scene, camera);
});

renderer.xr.addEventListener('sessionstart', () => {
    autoRotate = false
    controls.enabled = false;

    state.currentModel.position.z = -3;
    state.currentModel.position.y = -1;
});

renderer.xr.addEventListener('sessionend', () => {
    if (state.currentModel) {
        state.currentModel.position.set(0, 0.3, 0);
        state.currentModel.rotation.set(0, 0, 0);
        state.currentModel.scale.set(1, 1, 1);
        state.currentModel.visible = true;
    }

    controls.enabled = true;

    camera.position.set(2, 2, 2);
    controls.update();

    if (reticle) reticle.visible = false;

    hitTestSourceRequested = false;
    hitTestSource = null;

    autoRotate = true
});

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    if (state.currentModel && autoRotate) {
        state.currentModel.rotation.y += deltaTime * 0.3
    }

    controls.update()

    renderer.render(scene, camera)

    window.requestAnimationFrame(tick)
}

tick()